import { useSelector } from "react-redux";
import styled from "styled-components";

const PriceSection = ({ minPrice, setMinPrice, maxPrice, setMaxPrice, t }) => {
  const language = useSelector((state) => state.language);

  return (
    <FilterSection className={language}>
      <div className="filter-title">{t.carsFilter.price}</div>
      <PriceInputs className={language}>
        <InputDiv className={language}>
          <input
            type="number"
            placeholder={t.carsFilter.from}
            className="price-input"
            id="min"
            value={minPrice || ""}
            onChange={(e) => setMinPrice(e.target.value)}
          />
          <label htmlFor="min" className={language}>
            {t.sar}
          </label>
        </InputDiv>
        <InputDiv className={language}>
          <input
            type="number"
            placeholder={t.carsFilter.to}
            className="price-input"
            id="max"
            value={maxPrice || ""}
            onChange={(e) => setMaxPrice(e.target.value)}
          />
          <label htmlFor="max" className={language}>
            {t.sar}
          </label>
        </InputDiv>
      </PriceInputs>
    </FilterSection>
  );
};

const FilterSection = styled.div`
  margin-bottom: 15px;

  .filter-title {
    font-size: 18px;
    font-weight: 600;
    color: #2c3e50;
    margin-bottom: 15px;
    padding-bottom: 8px;
    border-bottom: 1px solid #e9ecef;
  }
  @media (max-width: 768px) {
    padding: 10px 15px;
  }
`;

const PriceInputs = styled.div`
  display: flex;
  gap: 12px;
`;

const InputDiv = styled.div`
  flex: 1;
  position: relative;

  .price-input {
    width: 100%;
    padding: 12px 15px;
    border: 2px solid #e9ecef;
    border-radius: 8px;
    font-size: 14px;
    transition: border-color 0.2s;

    &:focus {
      outline: none;
      border-color: #007bff;
    }

    &::placeholder {
      color: #6c757d;
    }

    /* Hide number input arrows */
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    &[type="number"] {
      -moz-appearance: textfield;
    }
  }

  label {
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 12px;
    color: #6c757d;
    font-weight: 500;
    pointer-events: none;
  }
  &.ar label,
  .ar & label {
    right: auto;
    left: 15px;
  }
  label.ar {
    right: auto !important;
    left: 15px !important;
  }
`;

export default PriceSection;
